import { RequirementType } from '@/utils/membership/types'
import { z } from 'zod'

export const requirementSchema = z.object({
  id: z.number().optional(),
  label: z.string().min(1, 'Requirement label is required'),
  description: z.string().optional(),
  type: z.nativeEnum(RequirementType),
  mandatory: z.boolean(),
  validationJson: z.string().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
})

export type RequirementFormValues = z.infer<typeof requirementSchema>
